import React from 'react';
import { Link } from 'react-router-dom';
import './NotFound.css';

const NotFound: React.FC = () => {
  return (
    <div className="not-found-page">
      <div className="not-found-content">
        <div className="error-code">404</div>
        <h1>Page Not Found</h1>
        <p className="error-description">
          The page you're looking for doesn't exist or has been moved.
        </p>
        
        <div className="suggested-actions">
          <h3>What you can do:</h3>
          <div className="action-links">
            <Link to="/" className="btn primary">
              🏠 Go to Home
            </Link>
            <Link to="/pricing" className="btn secondary">
              💰 View Pricing
            </Link>
            <Link to="/upload" className="btn secondary">
              ▢ Upload Documents
            </Link>
            <Link to="/dashboard" className="btn secondary">
              📊 Credit Dashboard
            </Link>
          </div>
        </div>

        <div className="help-section">
          <h4>Need Help?</h4>
          <p>If you believe this is an error, please contact our support team.</p>
          <div className="contact-info">
            <span>📧 info@use-proven.com</span>
            <span>📞 +1 (555) 123-4567</span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default NotFound;